import { createI18n } from 'vue-i18n'
import en from './locales/en'
import sl from './locales/sl'

export type AvailableLocales = 'sl' | 'en'

// The One Broadband site is an English-language brand site; en is the default.
const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'en',
    fallbackLocale: 'en',
    messages: { sl, en },
    availableLocales: ['en', 'sl'],
})

export default i18n
